/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImportUserRequest
 */
export interface ImportUserRequest {
    /**
     * 
     * @type {string}
     * @memberof ImportUserRequest
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserRequest
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserRequest
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserRequest
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {any}
     * @memberof ImportUserRequest
     */
    organizationId?: any | null;
    /**
     * 
     * @type {any}
     * @memberof ImportUserRequest
     */
    roleId?: any | null;
}

/**
 * Check if a given object implements the ImportUserRequest interface.
 */
export function instanceOfImportUserRequest(value: object): value is ImportUserRequest {
    return true;
}

export function ImportUserRequestFromJSON(json: any): ImportUserRequest {
    return ImportUserRequestFromJSONTyped(json, false);
}

export function ImportUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] === undefined ? undefined : json['firstName'] === null ? null : json['firstName'],
        'lastName': json['lastName'] === undefined ? undefined : json['lastName'] === null ? null : json['lastName'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'phoneNumber': json['phoneNumber'] === undefined ? undefined : json['phoneNumber'] === null ? null : json['phoneNumber'],
        'organizationId': json['organizationId'] === undefined ? undefined : json['organizationId'] === null ? null : json['organizationId'],
        'roleId': json['roleId'] === undefined ? undefined : json['roleId'] === null ? null : json['roleId'],
    };
}

export function ImportUserRequestToJSON(json: any): ImportUserRequest {
    return ImportUserRequestToJSONTyped(json, false);
}

export function ImportUserRequestToJSONTyped(value?: ImportUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'organizationId': value['organizationId'],
        'roleId': value['roleId'],
    };
}

